'use client';

import { useEffect } from 'react';
import HomeRoleRedirect from './HomeRoleRedirect.client';

export default function HomeScrollTop() {
  useEffect(() => {
    if (window.location.hash) return;

    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';

    const reset = () => window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    reset();
    const frame = window.requestAnimationFrame(reset);
    const timer = window.setTimeout(reset, 80);

    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(timer);
      window.history.scrollRestoration = previous;
    };
  }, []);

  return (
    <>
      <HomeRoleRedirect />
      <style>{`
        a[href="/login/teacher"][class*="min-h-11"],
        a[href="/login/teacher"][class*="min-h-12"] {
          background-color: rgb(124 58 237) !important;
          border-color: rgb(124 58 237) !important;
          color: white !important;
        }

        a[href="/login/teacher"][class*="min-h-11"]:hover,
        a[href="/login/teacher"][class*="min-h-12"]:hover {
          background-color: rgb(109 40 217) !important;
          border-color: rgb(109 40 217) !important;
        }
      `}</style>
    </>
  );
}
